import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { notification } from 'antd';
import moment from 'moment';

// services
import * as EventService from '../../../../services/bb-api/event';
import type { OrderData } from '../../../../services/bb-api/event';

export const LatestOrders: React.FC = () => {
	const [latestOrders, setLatestOrders] = useState<OrderData[]>([]);

	const getData = useCallback(() => {
		try {

			EventService.latestSubscribers().then(setLatestOrders);
		} catch (error) {
			const message = 'Der skete en fejl';
			notification.error({ message });
		}
	}, [])

	useEffect(() => {
		getData();
		const intervalTime = 60 * 1000 // 60 seconds
		const intervalId = setInterval(getData, intervalTime)
		return () => clearInterval(intervalId)
	}, [getData]);

	function firstname(fullName: string | null) {
		if (!fullName) return '-'
		
		const name = fullName.substring(0, fullName.indexOf(' '))
		if (name !== '') return name
		return fullName
	}

	function userAge(birthYear: number | null) {
		if (!birthYear) return '-'
		return new Date().getFullYear() - birthYear
	}

	return (
		<StyledContainer className='orders'>
			{/* Latest subscribers */}
			<div className='flex-item'>
				<div className='orders-container'>
					<p className='label'>Seneste køb</p>
					{latestOrders.map((order, index) => (
						<div className='order-item' key={index}>
							<p className='username'>{firstname(order.username)}</p>
							<p className='user-age'>{userAge(order.birthYear)} <span className='light-grey'>{userAge(order.birthYear) !== '-' && 'år'}</span></p>
							<p className='user-muni'>{order.municipality ? order.municipality : '-'}</p>
							<p className='event-title'>{order.eventTitle}</p>
							<p className='number-of-tickets'>{order.numberOfTickets} <span className='light-grey'>stk</span></p>
							<p className='total-price'>{order.totalPrice} <span className='currency'>DKK</span></p>
							<p className='order-created'>{moment(order.created).format('DD-MM-YYYY HH:mm')}</p>
						</div>
					))}
				</div>
			</div>
		</StyledContainer>
	);
};

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	color: #9ca3af;
	width: 100%;
	
	.flex-item {
		display: flex;
	}
	
	.orders-container {
		display: flex;
		flex-direction: column;
		width: 100%;
		background-color: rgba(31, 41, 55, 1);
		margin: 1em;
		padding: 12px 48px;
		border-radius: 12px;
		box-shadow: rgba(0,0,0,0.2) 0px 2px 8px 0px;
	}

	h1 {
		font-size: 84px;
		font-weight: 700;
		line-height: 1em;
		color: #ffffff;
		margin: 0;
	}

	p {
		margin: 0;
	}
	
	.order-item {
		display: flex;
		padding: 12px 0;
		color: #ffffff;
		
		p {
			font-size: 20px;
			font-weight: bold;
		}
	}
	
	.order-item + .order-item {
		border-top: 1px solid #394350;
	}
	
	.label {
		font-size: 32px;
		margin: 0;
	}

	.username {
		width: 240px;
	}

	.user-age {
		width: 75px;
	}

	.user-muni {
		width: 250px;
	}

	.event-title {
		width: 500px;
	}

	.total-price {
		width: 175px;
	}

	.number-of-tickets {
		width: 90px;
	}

	.currency {
		color: #9ca3af;
		padding-left: 6px;
	}

	.light-grey {
		color: #9ca3af;
	}
`;
